import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';
import RegisterForm from './RegisterForm';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    marginBottom: theme.spacing(10),
    [theme.breakpoints.up(600 + theme.spacing(3 * 2))]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  heading: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  message: {
    textAlign: 'center',
    padding: '20px',
  },
});

class RegisterPage extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.page}>
        <NavBar />
        <main className={classes.layout}>
          <div className={classes.appBarSpacer} />
          <Typography
            className={classes.heading}
            variant="h4"
            color="textSecondary"
          >
            Join the Nia Community
          </Typography>
          <RegisterForm />
          <FooterSpacer />
        </main>
        <Footer />
      </div>
    );
  }
}

RegisterPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RegisterPage);
